import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { useLang } from '../../../../../../hooks/use-lang';
import { TaskStatusType } from '../../../../../../store/api/tasks-api';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { statusTitleMap } from '../../../tasks/use-task-list';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  count: number[];
  name: string[];
}

export const useTasksStatusDistribution = (): ChartProps => {
  const { t } = useLang();
  const { list } = useDashboardStore();
  const data = list?.tasks_by_status as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data?.count) {
      return {
        series: data.count,
        options: {
          chart: {
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              offsetY: 0,
              offsetX: 40,
              startAngle: 0,
              endAngle: 270,
              barLabels: {
                enabled: true,
                useSeriesColors: true,
                offsetX: (10 - data.name.length) * -3,
                fontSize: '12px',
                formatter: function (seriesName, opts) {
                  const index = opts.seriesIndex;
                  return seriesName + ':  ' + data.count[index];
                },
              },
              dataLabels: {
                total: {
                  show: true,
                  label: t('Всего'),
                  fontSize: '16px',
                  formatter: function () {
                    return data.count.reduce((acc, count) => acc + count, 0).toString();
                  },
                },
                value: {
                  show: true,
                  fontSize: '18px',
                  formatter: function (val) {
                    return Number(val).toFixed(2) + '%';
                  },
                },
              },
            },
          },
          stroke: {
            lineCap: 'round',
          },
          labels: data.name.map((name) => t(statusTitleMap[name as TaskStatusType])),
          yaxis: {},
          xaxis: {},
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data, t]);

  return {
    series: chartData.series,
    options: chartData.options,
    type: 'radialBar',
    label: 'Распределение задач по статусам',
    subLabel:
      'Диаграмма отображает процентное соотношение статусов задач, формируя видение положения задач',
    wrapped: true,
  };
};
